import React, { forwardRef, ElementRef } from "react"
import { IconComponent } from "../../icons"
import { backgroundVariants } from "../../styles"
import { VariantProps, tv, classNames } from "../../utils"
import { FlexCenter, FlexCenterProps } from "../FlexCenter"
import { Text } from "../Text"

export type Props = { icon?: IconComponent; iconSize?: number } & VariantProps<
  typeof badgeVariants
> &
  FlexCenterProps

const badgeVariants = tv({
  base: "w-fit items-center gap-1 rounded py-0.5",
  variants: {
    variant: {
      success: backgroundVariants({
        background: "success",
        className: "animate-pulse text-success",
      }),
      error: backgroundVariants({
        background: "error",
        className: "text-error",
      }),
      warning: backgroundVariants({
        background: "warning",
        className: "text-warning",
      }),
      info: backgroundVariants({
        background: "additional-3",
        className: "text-text-secondary",
      }),
    },
    withIcon: {
      true: "pl-1 pr-1.5",
      false: "px-1.5",
    },
  },
})

export const Badge = forwardRef<ElementRef<typeof FlexCenter>, Props>(
  function Badge(
    {
      children,
      className,
      icon: IconComponent,
      iconSize = 20,
      variant = "info",
      ...rest
    },
    ref,
  ) {
    return (
      <FlexCenter
        className={classNames(
          badgeVariants({
            variant,
            withIcon: Boolean(IconComponent),
          }),
          className,
        )}
        ref={ref}
        {...rest}
      >
        {IconComponent ? <IconComponent size={iconSize} /> : null}
        <Text size="xs" weight={variant === "info" ? "regular" : "semibold"}>
          {children}
        </Text>
      </FlexCenter>
    )
  },
)
